import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import { ISlideshowDefinition } from '../../types';

export const props = withCompInfo<{}, ISlideshowDefinition, {}>()(
  [],
  (_, carmiData) => carmiData,
);

export const css = withCompInfo()([], () => ({}));

export default createComponentMapperModel({ props, css });
